import React from 'react';
import InformacionFabrizzio from "../components/InformacionFabrizzio";

const FabrizzioPage = () => (
    <>
        <InformacionFabrizzio/>
    </>
);

export default FabrizzioPage;